// UservansalTailwind.jsx
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import axios, { axios_post } from "../../axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { ToastMassage } from "toast";

// Keep layout wrappers if you still use them (or replace with your app layout)
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

/*
  Tailwind-only UI version of your original MUI component.
  - Ensure Tailwind CSS is configured in your project.
  - Keep backend helpers (axios_post, ToastMassage) as-is.
*/

export default function Uservansal() {
  const navigate = useNavigate();

  // --- states from original file ---
  const [selectedValue, setSelectedValue] = useState("");
  const [opened, setOpen] = useState(false); // export modal
  const [openMenuMain, setOpenMenuMain] = useState(false); // main menu (three-dot)
  const [openMenuBulk, setOpenMenuBulk] = useState(false); // bulk actions menu
  const [openActionConfirm, setActionConfirm] = useState(false);
  const [openInactiveConfirm, setInactiveConfirm] = useState(false);
  const [dialogbox, setDialogbox] = useState(false); // delete confirm
  const [openedRowMenuId, setOpenedRowMenuId] = useState(null); // per-row menu id
  const [data, setData] = useState([]);
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(true);
  const [SelectedUUID, setSelectedUUID] = useState([]); // array of uuids
  const [isDeleting, setIsDeleting] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  // formData kept (unused heavily here but preserved)
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    mobile: "",
  });

  // export radio state
  const [exportChoice, setExportChoice] = useState("");
  // export specific dates when needed
  const [exportFrom, setExportFrom] = useState("");
  const [exportTo, setExportTo] = useState("");

  // handleChanged (export radio)
  const handleChanged = (e) => setExportChoice(e.target.value);

  // --- API: fetch details ---
  const getdetails = async () => {
    setLoading(true);
    try {
      const response = await axios_post(true, "user_user_master/list");
      if (response) {
        if (response.status) {
          const records = response?.data?.records || [];
          setData(records);
        } else {
          ToastMassage(response.message, "error");
        }
      }
    } catch (err) {
      console.error("getdetails err:", err);
      ToastMassage("Failed to fetch records", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getdetails();
  }, []);

  // --- selection handlers ---
  const handleselection = (ids) => {
    // ids: array of numeric ids (we maintain mapping to uuid)
    const selectedrow = ids
      .map((id) => data.find((row) => row.id === id))
      .filter(Boolean);
    const newUUID = selectedrow.map((r) => r.uuid);
    setSelectedUUID(newUUID);
  };

  // checkbox per row toggle
  const toggleRowCheckbox = (rowId) => {
    const row = data.find((r) => r.id === rowId);
    if (!row) return;
    const uuid = row.uuid;
    setSelectedUUID((prev) => {
      if (prev.includes(uuid)) {
        return prev.filter((u) => u !== uuid);
      } else {
        return [...prev, uuid];
      }
    });
  };

  // select all visible rows on current page
  const toggleSelectAll = () => {
    const visible = paginatedRows;
    if (!selectAllChecked) {
      const allUUIDs = visible.map((r) => r.uuid).filter(Boolean);
      // union with existing
      setSelectedUUID((prev) => Array.from(new Set([...prev, ...allUUIDs])));
      setSelectAllChecked(true);
    } else {
      // remove visible uuids from selection
      const visibleUUIDs = new Set(visible.map((r) => r.uuid));
      setSelectedUUID((prev) => prev.filter((u) => !visibleUUIDs.has(u)));
      setSelectAllChecked(false);
    }
  };

  // open delete confirm
  const handleClickOpened = (orderRow) => {
    // your original called with id; preserve both behaviors:
    // If passed an id, try to find row
    const row =
      typeof orderRow === "object" && orderRow !== null
        ? orderRow
        : data.find((r) => r.id === orderRow) || {};
    setOrderData(row);
    setDialogbox(true);
  };

  const handleClosing = () => {
    setDialogbox(false);
    setActionConfirm(false);
    setInactiveConfirm(false);
  };

  const handleClickactionOpen = () => setActionConfirm(true);
  const handleClickinactiveOpen = () => setInactiveConfirm(true);

  const handleActiveModalSubmit = async (status) => {
    setActionConfirm(false);
    // preserve original commented logic: send SelectedUUID to bulk endpoint
    try {
      // Example: submit selected UUIDs
      // await axios_post(true, 'global/bulk-action', { ids: SelectedUUID, action: status })
      // getdetails(); ToastMassage(...); setInactiveConfirm(false)
      console.log("Bulk action (active):", SelectedUUID, status);
      ToastMassage("Bulk action simulated", "success");
    } catch (err) {
      console.error(err);
      ToastMassage("Bulk action failed", "error");
    }
  };

  const handleActiveModalSubmitInactive = async (status) => {
    setDialogbox(false);
    setActionConfirm(false);
    setInactiveConfirm(false);
    try {
      console.log("Bulk action (inactive):", SelectedUUID, status);
      ToastMassage("Bulk action simulated", "success");
    } catch (err) {
      console.error(err);
      ToastMassage("Bulk action failed", "error");
    }
  };

  // --- delete handler ---
  const handleDelete = async () => {
    const idToDelete = orderData?.id || orderData;
    setIsDeleting(true);
    try {
      const response = await axios_post(true, "user_user_master/delete", {
        id: idToDelete,
      });
      if (response?.status === true) {
        getdetails();
        ToastMassage(response?.message, "success");
        setOrderData({});
        setDialogbox(false);
      } else {
        ToastMassage(response?.message, "error");
        setDialogbox(false);
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      ToastMassage("Delete failed", "error");
    } finally {
      setIsDeleting(false);
    }
  };

  // --- edit/view ---
  const handleEdit = (id, type) => {
    if (type === "edit") {
      navigate(`/uservansal/edit/${id}`);
    } else if (type === "view") {
      navigate(`/uservansal/view/${id}`);
    }
  };

  // --- columns/rows (we'll render table manually) ---
  const columns = [
    { key: "created_at", label: "DATE", width: "w-56" },
    { key: "firstname", label: "Firstname", width: "w-36" },
    { key: "lastname", label: "Lastname", width: "w-36" },
    { key: "email", label: "Email", width: "w-44" },
    { key: "mobile", label: "Mobile", width: "w-36" },
  ];

  // --- filtering ---
  const filteredRows = useMemo(() => {
    if (!searchTerm) return data;
    const s = searchTerm.toLowerCase();
    return data.filter((row) => {
      return (
        (row.firstname || "").toLowerCase().includes(s) ||
        (row.lastname || "").toLowerCase().includes(s) ||
        (row.email || "").toLowerCase().includes(s) ||
        (row.mobile || "").toLowerCase().includes(s)
      );
    });
  }, [searchTerm, data]);

  // --- pagination ---
  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
  useEffect(() => {
    if (page >= totalPages) setPage(0);
  }, [totalPages]);

  const paginatedRows = filteredRows.slice(
    page * pageSize,
    page * pageSize + pageSize
  );

  // rerun selectAllChecked when selection changes / page changes
  useEffect(() => {
    const visibleUUIDs = paginatedRows.map((r) => r.uuid).filter(Boolean);
    const allSelected =
      visibleUUIDs.length > 0 &&
      visibleUUIDs.every((u) => SelectedUUID.includes(u));
    setSelectAllChecked(Boolean(allSelected));
  }, [paginatedRows, SelectedUUID]);

  // per-row action menu handlers
  const toggleRowMenu = (id) => {
    setOpenedRowMenuId((prev) => (prev === id ? null : id));
  };

  // small helpers
  const formatDate = (val) =>
    val ? moment(val).format("DD MMM YYYY hh:mm A") : "-";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Delete confirmation modal */}
      {dialogbox && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg w-11/12 max-w-md shadow-lg">
            <div className="px-6 py-4 border-b">
              <h3 className="text-lg font-semibold">Are you sure?</h3>
            </div>
            <div className="p-6">
              <p>
                Do you really want to delete this{" "}
                <span className="font-semibold">{orderData?.name}</span> User
                JERP?
              </p>
            </div>
            <div className="px-6 py-4 border-t flex justify-end gap-2">
              <button
                onClick={handleClosing}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={isDeleting}
                className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bulk action confirm modal */}
      {openActionConfirm && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg w-11/12 max-w-md shadow-lg">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeWidth="2" d="M12 9v2m0 4h.01M12 3v2m0 14v2" />
                </svg>
                <h3 className="text-lg font-semibold">
                  Are you sure want to mark as active selected Records
                </h3>
              </div>
              <div className="text-sm text-gray-600">
                Selected: {SelectedUUID.length} records
              </div>
            </div>
            <div className="px-6 py-4 border-t flex justify-end gap-2">
              <button
                onClick={() => setActionConfirm(false)}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
              >
                No, mistake!
              </button>
              <button
                onClick={() => handleActiveModalSubmit("active")}
                className="px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700"
              >
                Yes, mark as active !
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Inactive confirm modal */}
      {openInactiveConfirm && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg w-11/12 max-w-md shadow-lg">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeWidth="2" d="M12 9v2m0 4h.01M12 3v2m0 14v2" />
                </svg>
                <h3 className="text-lg font-semibold">
                  Are you sure want to mark as inactive selected Records
                </h3>
              </div>
              <div className="text-sm text-gray-600">
                Selected: {SelectedUUID.length} records
              </div>
            </div>
            <div className="px-6 py-4 border-t flex justify-end gap-2">
              <button
                onClick={() => setInactiveConfirm(false)}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
              >
                No, mistake!
              </button>
              <button
                onClick={() => handleActiveModalSubmitInactive("inactive")}
                className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
              >
                Yes, mark as inactive !
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Export modal */}
      {opened && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg w-11/12 max-w-lg shadow-lg">
            <div className="flex items-center justify-between px-6 py-3 border-b">
              <h3 className="text-lg font-semibold">Export</h3>
              <button
                onClick={() => setOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <div className="p-6">
              <div className="mb-4">
                <label className="block mb-2">Choose Customers</label>
                <div className="flex flex-col gap-2">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="exportopt"
                      className="form-radio"
                      value="auto"
                      checked={exportChoice === "auto"}
                      onChange={(e) => handleChanged(e)}
                    />
                    <span className="ml-2"> Customer</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="exportopt"
                      className="form-radio"
                      value="add"
                      checked={exportChoice === "add"}
                      onChange={(e) => handleChanged(e)}
                    />
                    <span className="ml-2"> Specific Customer</span>
                  </label>
                </div>
                {exportChoice === "add" && (
                  <div className="mt-4 grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm mb-1">From</label>
                      <input
                        type="date"
                        value={exportFrom}
                        onChange={(e) => setExportFrom(e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                    <div>
                      <label className="block text-sm mb-1">To</label>
                      <input
                        type="date"
                        value={exportTo}
                        onChange={(e) => setExportTo(e.target.value)}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div>
                <div className="mb-2">Export As :</div>
                <label className="inline-flex items-center mr-4">
                  <input
                    type="radio"
                    name="export-as"
                    value="csv"
                    className="form-radio"
                  />
                  <span className="ml-2">CSV (Comma Separated Value)</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="export-as"
                    value="xls"
                    className="form-radio"
                  />
                  <span className="ml-2">XLS (Microsoft Excel Compatible)</span>
                </label>
              </div>
            </div>
            <div className="px-6 py-4 border-t flex justify-end gap-2">
              <button
                onClick={() => {
                  // trigger export logic here
                  setOpen(false);
                  ToastMassage("Export simulated", "success");
                }}
                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                Export
              </button>
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Container */}
      <div className="p-6">
        <div className="bg-white rounded-lg shadow">
          {/* header bar */}
          {/* header bar */}
          <div className="bg-gradient-to-r from-sky-500 to-cyan-500 rounded-t-lg p-4 relative">
            {/* CENTERED SEARCH BOX */}
            <div className="absolute left-1/2 -translate-x-1/2 top-4">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border px-2 py-1 rounded w-[400px] shadow"
              />
            </div>

            {/* LEFT + RIGHT CONTENT */}
            <div className="flex items-center">
              <div className="flex-1 flex items-center gap-4">
                <div className="flex items-center gap-2 text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M10 4a2 2 0 11-0 4 2 2 0 010-4zm0 6a6 6 0 00-6 6h12a6 6 0 00-6-6z" />
                  </svg>
                  <span className="font-semibold">User JERP</span>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Link to="/master/uservansal" className="inline-block">
                  <button className="bg-white/20 text-white px-3 py-1 rounded-md hover:bg-white/30">
                    + New
                  </button>
                </Link>

                {SelectedUUID.length > 0 && (
                  <div className="relative">
                    <button
                      onClick={() => setOpenMenuBulk((p) => !p)}
                      className="bg-white/20 text-white px-3 py-1 rounded-md hover:bg-white/30"
                    >
                      Bulk Actions
                    </button>
                    {openMenuBulk && (
                      <div className="absolute right-0 mt-2 w-44 bg-white rounded shadow border">
                        <button
                          onClick={() => {
                            setOpenMenuBulk(false);
                            handleClickactionOpen();
                          }}
                          className="block w-full text-left px-4 py-2 hover:bg-gray-50"
                        >
                          Mark as Active
                        </button>
                        <button
                          onClick={() => {
                            setOpenMenuBulk(false);
                            handleClickinactiveOpen();
                          }}
                          className="block w-full text-left px-4 py-2 hover:bg-gray-50"
                        >
                          Mark as Inactive
                        </button>
                      </div>
                    )}
                  </div>
                )}

                <div className="relative">
                  <button
                    onClick={() => setOpenMenuMain((p) => !p)}
                    className="bg-white/20 text-white px-2 py-1 rounded-md hover:bg-white/30"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </button>

                  {openMenuMain && (
                    <div className="absolute right-0 mt-2 w-40 bg-white rounded shadow border z-10">
                      <button
                        onClick={() => {
                          setOpenMenuMain(false);
                          ToastMassage("Import clicked", "info");
                        }}
                        className="block w-full text-left px-4 py-2 hover:bg-gray-50"
                      >
                        Import
                      </button>
                      <button
                        onClick={() => {
                          setOpenMenuMain(false);
                          setOpen(true);
                        }}
                        className="block w-full text-left px-4 py-2 hover:bg-gray-50"
                      >
                        Export
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Table Container */}
          <div className="p-4">
            <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
              {/* table */}
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-100 border-b">
                    <tr className="text-gray-700">
                      <th className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={selectAllChecked}
                          onChange={toggleSelectAll}
                          className="h-4 w-4 rounded border-gray-400"
                        />
                      </th>
                      <th className="px-4 py-3 text-left font-medium">Date</th>
                      <th className="px-4 py-3 text-left font-medium">
                        Firstname
                      </th>
                      <th className="px-4 py-3 text-left font-medium">
                        Lastname
                      </th>
                      <th className="px-4 py-3 text-left font-medium">Email</th>
                      <th className="px-4 py-3 text-left font-medium">
                        Mobile
                      </th>
                      <th className="px-4 py-3 text-left font-medium">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan={7}
                          className="px-6 py-8 text-center text-gray-500"
                        >
                          Loading...
                        </td>
                      </tr>
                    ) : paginatedRows.length === 0 ? (
                      <tr>
                        <td
                          colSpan={7}
                          className="px-6 py-8 text-center text-gray-500"
                        >
                          No records found
                        </td>
                      </tr>
                    ) : (
                      paginatedRows.map((row, index) => (
                        <tr
                          key={row.id}
                          className={`border-b ${
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          } hover:bg-gray-100 transition`}
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              checked={SelectedUUID.includes(row.uuid)}
                              onChange={() => toggleRowCheckbox(row.id)}
                              className="h-4 w-4 rounded border-gray-400"
                            />
                          </td>

                          <td className="px-4 py-3">
                            {formatDate(row.created_at)}
                          </td>
                          <td className="px-4 py-3">{row.firstname || "-"}</td>
                          <td className="px-4 py-3">{row.lastname || "-"}</td>
                          <td className="px-4 py-3">{row.email || "-"}</td>
                          <td className="px-4 py-3">{row.mobile || "-"}</td>

                          <td className="px-4 py-3 relative">
                            <button
                              onClick={() => toggleRowMenu(row.id)}
                              className="p-1 rounded hover:bg-gray-200 transition text-lg"
                            >
                              ⋮
                            </button>

                            {openedRowMenuId === row.id && (
                              <div className="absolute right-2 top-8 z-20 w-40 bg-white rounded-lg shadow-lg border">
                                <button
                                  onClick={() => {
                                    toggleRowMenu(row.id);
                                    handleEdit(row.id, "edit");
                                  }}
                                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                  Edit
                                </button>

                                <button
                                  onClick={() => {
                                    toggleRowMenu(row.id);
                                    handleEdit(row.id, "view");
                                  }}
                                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                                >
                                  View
                                </button>

                                <button
                                  onClick={() => {
                                    toggleRowMenu(row.id);
                                    handleClickOpened(row);
                                  }}
                                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* pagination & page size */}
              <div className="p-4 flex items-center justify-between bg-gray-50 border-t">
                {/* rows per page */}
                <div className="flex items-center gap-2 text-sm">
                  <span>Rows per page:</span>
                  <select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      setPage(0);
                    }}
                    className="border px-2 py-1 rounded bg-white"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                  </select>
                </div>

                {/* pagination */}
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-gray-600">
                    {filteredRows.length} records
                  </span>

                  <button
                    onClick={() => setPage((p) => Math.max(0, p - 1))}
                    disabled={page === 0}
                    className="px-3 py-1 rounded bg-white border hover:bg-gray-100 disabled:opacity-50"
                  >
                    Prev
                  </button>

                  <span>
                    Page {page + 1} of {totalPages}
                  </span>

                  <button
                    onClick={() =>
                      setPage((p) => Math.min(totalPages - 1, p + 1))
                    }
                    disabled={page >= totalPages - 1}
                    className="px-3 py-1 rounded bg-white border hover:bg-gray-100 disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
